import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { Label, Alert } from "reactstrap";
import {utils} from "../../../utils/utils"
export default class DropFiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null
        }
        this.zoneStyle = {
            width: "100%",
            height: 150,
            border: "2px dashed #888",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        };
    }

    onDrop = files => {
        const newFile = files[0];
        this.setState({ file: newFile, errorMessage: [] });
        this.props.load_file(newFile)
    };

    getCondition = (cpo_register, selected_oet_item) => {
        /**
        * Handles condition for expiry date trigger.
        * If customer team is Bharti, expired_days taken from OET item
        * else expired_days taken from CPO instance
        */
        let expired_days = null;
        let condition = null;

        expired_days = selected_oet_item ? selected_oet_item.expired_days : null
        condition = selected_oet_item ? 
                expired_days > 0 && expired_days <= 30 && utils.check_validation_type(cpo_register)
                : false
        if (['wbs'].includes(cpo_register.validation_type) ){
            expired_days = cpo_register.expired_days
            condition = expired_days ?
                utils.check_validation_type(cpo_register) && expired_days > 60 && expired_days < 90
                : false
        }
        return condition
    }

    render() {
        const { cpo_register, selected_oet_item } = this.props;
        const { file } = this.state
        const drop_files = this.getCondition(cpo_register, selected_oet_item) ? <React.Fragment>
            {file && <div className="col-md-12">
                <Alert>{file.name}</Alert>
            </div>}
            <Label for="itemInput">Offline approval</Label>
            <Dropzone
                disableClick
                multiple={false}
                style={this.zoneStyle}
                onDrop={this.onDrop}
                onFileDialogCancel={this.onCancel}
            >
                {({ isDragActive, isDragReject, open }) => {
                    if (isDragActive) {
                        return <p>File accepted</p>;
                    }
                    if (isDragReject) {
                        return <p>Files rejected</p>;
                    }
                    return (
                        <React.Fragment>
                            <p>Dropp file here ... or</p>
                            <button className="btn btn-primary" type="button" onClick={() => open()}>
                                Browse File
                            </button>
                        </React.Fragment>
                    );
                }}
            </Dropzone>
        </React.Fragment> : null
        return drop_files
    }
}